import React from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';

// Mostrará los toast de notificación en la aplicación
const withNotification = (WrappedComponent) => (
  (props) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const onClose = (event, reason, key) => {
      if (reason === 'clickaway') {
        closeSnackbar(key);
      }
    };
    const appInfo = (message) => enqueueSnackbar(message, {
      variant: 'info',
      onClose: (event, reason, key) => onClose(event, reason, key),
    });
    const appSuccess = (message) => enqueueSnackbar(message, {
      variant: 'success',
      onClose: (event, reason, key) => onClose(event, reason, key),
    });
    const appWarning = (message) => enqueueSnackbar(message, {
      variant: 'warning',
      onClose: (event, reason, key) => onClose(event, reason, key),
    });
    const appError = (message, errorInfo) => {
      enqueueSnackbar(message, {
        variant: 'error',
        onClose: (event, reason, key) => onClose(event, reason, key),
      });
      // ToDo: Reemplazar con un log de error.
      // eslint-disable-next-line no-console
      console.log(errorInfo);
    };
    const appNotify = (message) => enqueueSnackbar(message, {
      onClose: (event, reason, key) => onClose(event, reason, key),
    });
    return (
      <WrappedComponent
        appInfo={appInfo}
        appWarning={appWarning}
        appSuccess={appSuccess}
        appError={appError}
        appNotify={appNotify}
        {...props}
      />
    );
  }
);

export const propTypes = {
  appInfo: PropTypes.func.isRequired,
  appSuccess: PropTypes.func.isRequired,
  appWarning: PropTypes.func.isRequired,
  appError: PropTypes.func.isRequired,
  appNotify: PropTypes.func.isRequired,
};

export default withNotification;
